import React from "react";
import AuthContainer, {
	AuthContainerSignIn,
	AuthContainerSignUp,
	AuthContainerTitle,
} from "@insightfulscience/atomic-react/r1/molecules/AuthContainer";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import WithConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import { useLocale } from "@insightfulscience/smart-react/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { bgColorWhite } from "@insightfulscience/atomic-react/utils/color";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import SiteLayout from "../../SiteLayout";
import SignInForm from "../../SignInForm";
import SignUpFrom from "../../SignUpForm";
import { isNotAuthorized } from "../../services/authService/status";
import routes from "../../routes";
import { toReturnUrl } from "../../routing-utils";
import authService from "../../services/authService";
import WithServices from "../../services";
import withErrorHandling from "../../AppError/withErrorHandling";
import WithMaintenance from "../../Maintenance/WithMaintenance";

function LoginPage() {
	const [t] = useLocale("login-page");

	return (
		<SiteLayout isWrapper={false} bodyClassName={bgColorWhite}>
			<PageMeta title={t("PAGE_TITLE")}>
				<PageMeta.Canonical href={t("PAGE_CANONICAL")} />
			</PageMeta>
			<PageTitle title={t("PAGE_TITLE")} />
			<AuthContainer>
				<AuthContainerSignUp>
					<AuthContainerTitle weight="thin" data-qa-selector="signUp-form-title">
						{t("SIGNUP_FORM_TITLE")}
					</AuthContainerTitle>
					<SignUpFrom />
				</AuthContainerSignUp>
				<AuthContainerSignIn>
					<AuthContainerTitle weight="thin" data-qa-selector="signIn-form-title">
						{t("SIGNIN_FORM_TITLE")}
					</AuthContainerTitle>
					<SignInForm />
				</AuthContainerSignIn>
			</AuthContainer>
		</SiteLayout>
	);
}

LoginPage.preConditions = [
	[isNotAuthorized, toReturnUrl(routes.myAccount)], // pre-condition check
];

LoginPage.services = {
	authService,
};

export default pipe(
	LoginPage,
	WithConditions,
	withErrorHandling,
	WithServices,
	WithMaintenance({ level: "CUD" }),
);
